module.exports = __webpack_public_path__ + "static/img/logo.219d6e97.png";